module.exports = __webpack_public_path__ + "static/img/ubo_icon.3d5c5d20.png";